import script from "./bill-key-rgst.vue?vue&type=script&setup=true&lang=js"
export * from "./bill-key-rgst.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__